<template>
  <sPopover
    ref="timeSpan"
    :disabled="disabled"
    :open-delay="300"
    placement="bottom"
    trigger="click">
    <div
      slot="reference"
      class="time-span__label"
      :class="[disabled ? 'disabled' : '', mode ]">
      <span
        v-if="day"
        class="mr-1">
        {{ computedValue.day }} {{ $tc('Common.day', computedValue.day) }}</span>
      <span>{{ computedValue.time }}</span>
    </div>
    <div class="time-span__card">
      <template v-if="day">
        <div class="text-capitalize mb-1">
          {{ $tc('Common.day', 0) }}
        </div>
        <sInputNumber
          :data-qa="`${dataQa}-time-span-day`"
          :disabled="disabled"
          placeholder="0"
          :precision="0"
          :value="computedValue.day"
          @update:value="value => computedValue = `${value}.${computedValue.time}`"/>
      </template>
      <div class="text-capitalize mt-3 mb-1">
        {{ $tc('Common.hour', 0) }}
      </div>
      <v-time-picker
        ref="timePicker"
        class="time-span"
        color="var(--v-secondary__green_not_active-base)"
        :data-qa="`${dataQa}-time-span-time`"
        format="24hr"
        full-width
        :locale="$i18n.locale"
        :max="timeMax"
        :min="timeMin"
        scrollable
        :use-seconds="second"
        :value="computedValue.time"
        @click:minute="second ? null : applyTime()"
        @click:second="applyTime()"/>
    </div>
  </sPopover>
</template>
<script>

export default {
  name: 'timeSpan',
  methods: {
    pad(string) {
      string = string?.trim()
      if (!string) { return '00' }
      return  ('000' + string).slice(-2)
    },
    applyTime() {
      const {inputHour, inputMinute, inputSecond } = this.$refs.timePicker
      this.$refs.timeSpan.doClose()
      this.computedValue = `${this.computedValue.day}.${inputHour}:${inputMinute}:${this.second ? inputSecond : '00'}`
      this.$nextTick(() => {
        this.$refs.timePicker.selectingHour = true
      })
    }
  },
  computed: {
    computedValue: {
      get() {
        const length = this.value?.length || 0
        const dotSymbol = this.value?.indexOf('.') || 0
        if (!this.value || !length) {
          return {
            day: 0,
            time: '00:00:00'
          }
        }
        const day = dotSymbol ? this.value
          .slice(0, dotSymbol) : 0
        const timeString = this.value
          .slice(dotSymbol ? dotSymbol + 1 : 0, length)
        const timeSplit = timeString.split(':')
        const time = `${this.pad(timeSplit[0])}:${this.pad(timeSplit[1])}:${this.pad(timeSplit[2])}`
        return {
          day,
          time
        }
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  props: {
    value: {
      type: String
    },
    dataQa: {
      type: String,
      default: 'time-span'
    },
    disabled: {
      type: Boolean
    },
    propName: {
      type: String
    },
    day: {
      type: Boolean,
      default: true
    },
    second: {
      type: Boolean,
      default: true
    },
    mode: {
      type: String,
      validator: function (value) {
        const correct = ['', 'text'].indexOf(value) !== -1
        return correct
      },
      default: '',
    },
    timeMax: {
      type: String,
      default: '23:59:59'
    },
    timeMin: {
      type: String,
      default: '00:00:00'
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .time-span {
  .v-picker__body.theme--light {
    background: var(--v-main__light_green-base);
  }
  .theme--light.v-time-picker-clock {
    background: var(--v-secondary__green_chosen-base);
  }
  .v-time-picker-clock__hand {
    left: calc(50% - 4px);
    width: 5px;
  }
  .v-time-picker-clock__inner {
    position: absolute;
    bottom: 20px;
    left: 20px;
    right: 20px;
    top: 20px;
  }
  .v-picker__title {
    padding: 5px;
  }
  .v-time-picker-title {
    justify-content: center;
  }
  .v-time-picker-title__time {
    .v-picker__title__btn,
      span {
      font-size: 18px;
      height: auto;
    }
  }
}
.sFormItem.is-error .time-span__label {
  border-color: var(--color-error);
}
.time-span {
  &__label {
    background-color: var(--white-color);
    border-radius: 31px;
    border: 2px solid var(--color-main-green);
    color: var(--text-color);
    display: inline-block;
    height: 40px;
    line-height: 38px;
    padding: 0 15px;
    cursor: pointer;
    &.disabled {
      opacity: 0.8;
      cursor: auto;
    }
    &.text {
			border-color: transparent;
			background: transparent;
      padding: 0;
      line-height: 1;
      height: auto;
    }
  }
  &__card {
    border-radius: 5px;
    border: 1px solid var(--color-main-green);
    padding: 10px;
    background: var(--v-main__light_green-base);
  }
}
</style>
